export default __webpack_public_path__ + "fonts/ob_3.f9c5ed89aafbf04e2d71bb8616e1b5d6.png";